import { Component, OnInit } from '@angular/core';
import { PhrutillsService } from '../../generic/phrutills.service';
declare var $: any;
@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements OnInit {
  ischeckinThorughCard: boolean = false;
  constructor(private _phrutilService: PhrutillsService) { }

  ngOnInit() {
    this._phrutilService.CheckinThroughCard$.subscribe(checkinType => {
      if (checkinType == "scan") {
        this.ischeckinThorughCard = true;
      } else {
        this.ischeckinThorughCard = false;
      }
    });
  }
}
